import { Pipe, PipeTransform } from '@angular/core';
import { Store } from '@ngrx/store';
import { first } from 'rxjs/operators';
import { UserStoreSelectors, UserStoreState } from '@core-lib/store/user-store';
import { UserPermission } from '@core-lib/enums/user-permission.enum';

@Pipe({
    name: 'hasPermission',
    standalone: false
})
export class HasPermissionPipe implements PipeTransform {
	constructor(private store: Store<UserStoreState.IUserStoreState>) {}

	transform(value: UserPermission | UserPermission[]): boolean {
		let permissions: UserPermission[] = [];
		let isAllowed: boolean = false;

		if (Array.isArray(value)) {
			permissions = value;
		} else {
			permissions.push(value);
		}

		this.store
			.select(UserStoreSelectors.selectUserHasPermissions, { permissions })
			.pipe(first())
			.subscribe(a => (isAllowed = a));

		return isAllowed;
	}
}
